const { request } = require('../../rest/index');
const endpoints = require('../../config/endpoints');

const fetchPreviewAssets = (productId, customisations) => {
  const params = customisations;
  const endpoint = endpoints.buildPreviewUrl(productId, params);

  if (
    endpoints.isChameleon(productId) ||
    endpoints.isMuseDirty(productId) ||
    endpoints.isMu2(productId)
  ) {
    return request.post(endpoint, params, {
      headers: {
        'content-type': 'application/json',
      },
    });
  }

  return request.get(endpoint, null);
};

const formatBody = (productId, response) => {
  let body = {};
  const isMuse = endpoints.isMuseDirty(productId);
  if (isMuse) {
    body.images = response.body;
  } else if (endpoints.isChameleon(productId)) {
    body = response.body;
  } else { // Mu2
    body.images = response.body.toc.map(img => img.url);
  }
  return body;
};

module.exports = {
  fetchPreviewAssets,
  formatBody,
};
